import { NameDto } from '../../Common/Types'

export enum AmlRiskLevelType {
  Low = 10,
  Medium = 20,
  High = 30,
  Undefined = 100,
}

export const getAMLScore =
  (categories: NameDto[]) =>
  (
    score = 0
  ): {
    name: string
    color: string
  } => {
    const name = getAmlText(categories)(score)
    const color = getAmlColor(score)

    return { name, color }
  }

const getAmlText = (categories: NameDto[]) => (score: number) => {
  if (isAmlRiskLow(score)) {
    return getAmlTextName(categories.filter(filterAmlLow))
  }

  if (isAmlRiskMedium(score)) {
    return getAmlTextName(categories.filter(filterAmlMedium))
  }

  if (isAmlRiskHigh(score)) {
    return getAmlTextName(categories.filter(filterAmlHigh))
  }

  return ''
}

const getAmlColor = (score: number) => {
  if (isAmlRiskLow(score)) {
    return '#52c41a'
  }

  if (isAmlRiskMedium(score)) {
    return '#FFA354'
  }

  if (isAmlRiskHigh(score)) {
    return '#A22525'
  }

  return '#d2CCFF'
}

const isAmlRiskLow = (score: number) => {
  return score >= 0 && score <= 17
}

const isAmlRiskMedium = (score: number) => {
  return score >= 18 && score <= 44
}

const isAmlRiskHigh = (score: number) => {
  return score >= 45
}

const getAmlTextName = (categories: NameDto[]) => {
  const [category] = categories
  return category?.name ?? ''
}

const filterAmlLow = (category: NameDto) => {
  return category.id === AmlRiskLevelType.Low
}

const filterAmlMedium = (category: NameDto) => {
  return category.id === AmlRiskLevelType.Medium
}

const filterAmlHigh = (category: NameDto) => {
  return category.id === AmlRiskLevelType.High
}
